<template>
  <div>
    <table class="table table-sm" v-if="!isMobile">
      <thead class="thead-light text-center">
      <tr>
        <th>{{'rotation.report.started_at' | trans}}</th>
        <th>{{'rotation.report.auditor' | trans}}</th>
        <th>{{'rotation.report.successful_answer_rate' | trans}}</th>
        <th>{{'rotation.report.hint_rate' | trans}}</th>
        <th>{{'rotation.report.fail_answer_rate' | trans}}</th>
        <th>{{'rotation.report.no_answer_rate' | trans}}</th>
        <th>{{'rotation.report.all_approaches_count' | trans}}</th>
        <th></th>
      </tr>
      </thead>
      <tbody class="gray-700 text-center">
      <tr v-if="!isLoaded">
        <td colspan="7">
          <loader class="table-loader" messages="home.labels.loading_message_table"></loader>
        </td>
      </tr>
      <tr v-for="report in reports" :key="reports.id" v-if="!isEmptyReports && isLoaded">
        <td>{{report.startedAt.date | toLocaleDateTime}}</td>
        <td>{{report.auditor.name}}</td>
        <td>{{report.successRate}}</td>
        <td>{{report.promptRate}}</td>
        <td>{{report.failRate}}</td>
        <td>{{report.incompleteRate}}</td>
        <td>{{report.totalCount}}</td>
        <td class="text-center">
          <a href="#" @click.prevent="exportReport(report.id)">
            <mdc-icon icon="save_alt"></mdc-icon>
          </a>
        </td>
      </tr>
      </tbody>
    </table>

    <div class="mobile-table" v-else>
      <div class="mobile-table__head">
        {{'rotation.reports' | trans}}
      </div>
      <div class="mobile-table__body">
        <div class="d-flex" v-if="!isLoaded">
          <loader class="table-loader" messages="home.labels.loading_message_table"></loader>
        </div>

        <div class="mobile-table__row mx-0" v-for="report in reports" :key="reports.id" v-if="!isEmptyReports && isLoaded">
          <div class="description pt-2">
            <div>
              <p class="gray-dark head">{{'rotation.report.started_at' | trans}}</p>
              <p class="p-2 gray-700">{{report.startedAt.date | toLocaleDateTime}}</p>
            </div>

            <div>
              <p class="gray-dark head">{{'rotation.report.auditor' | trans}}</p>
              <p class="p-2 gray-700">{{report.auditor.name}}</p>
            </div>

            <div>
              <p class="gray-dark head">{{'rotation.report.successful_answer_rate' | trans}}</p>
              <p class="p-2 gray-700">{{report.successRate}}</p>
            </div>

            <div>
              <p class="gray-dark head">{{'rotation.report.hint_rate' | trans}}</p>
              <p class="p-2 gray-700">{{report.promptRate}}</p>
            </div>

            <div>
              <p class="gray-dark head">{{'rotation.report.fail_answer_rate' | trans}}</p>
              <p class="p-2 gray-700">{{report.failRate}}</p>
            </div>

            <div>
              <p class="gray-dark head">{{'rotation.report.no_answer_rate' | trans}}</p>
              <p class="p-2 gray-700">{{report.incompleteRate}}</p>
            </div>

            <div>
              <p class="gray-dark head">{{'rotation.report.all_approaches_count' | trans}}</p>
              <p class="p-2 gray-700">{{report.totalCount}}</p>
            </div>

            <div>
              <p class="gray-dark head">{{'dro.report.download_report' | trans}}</p>
              <p class="p-2">
                <a href="#" @click.prevent="exportReport(report.id)">
                  <mdc-icon icon="save_alt"></mdc-icon>
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="text-center" v-if="isEmptyReports && isLoaded">
      <h5>{{'rotation.no_data' | trans }}</h5>
    </div>

    <div v-if="!isEmptyReports">
      <div class="row" v-if="paginate.lastPage > 1">
        <div class="col-md-12">
          <nav class="nav justify-content-center justify-content-md-start">
            <paginate
                :page-count="paginate.lastPage"
                :page-range="paginate.pageRange"
                :margin-pages="paginate.marginPages"
                :force-page="paginate.forcePage"
                :click-handler="onPaginationClick"
                :container-class="'pagination pagination-sm'"
                :page-class="'page-item'"
                :page-link-class="'page-link'">

              <span slot="prevContent" class="page-link">&laquo;</span>
              <span slot="nextContent" class="page-link">&raquo;</span>
            </paginate>
          </nav>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Manager from '../api/Manager';
  import {mapState, mapGetters} from 'vuex';
  import isEmpty from 'lodash/isEmpty';
  import Loader from '../../loader/components/Loader';
  import {pagination} from '../../../common/mixins/pagination';


  export default {
    data() {
      return {
        reports: [],
        isLoaded: true,
      };
    },
    components: {Loader},
    mixins: [pagination],
    computed: {
      ...mapState(['route']),
      ...mapGetters('mobile', [
        'isMobile',
      ]),
      isEmptyReports: function () {
        return isEmpty(this.reports);
      },
    },
    created() {
      let assigneeId = this.route.params.clientId;
      this.fetchReports(assigneeId, this.paginate.perPage, this.paginate.page);
    },
    methods: {
      fetchReports: async function (assigneeId, perPage, page) {
        try {
          this.isLoaded = false;
          let response = await Manager.getReports(assigneeId, perPage, page);

          this.reports = response.data.data.items;
          this.setPaginate(response.data.data);
          this.isLoaded = true;
        } catch (error) {
          console.dir(error);
          this.isLoaded = true;
        }
      },
      exportReport: async function (id) {
        try {
          let response = await Manager.exportReports(id)
              .then(response => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'report_' + id + '.pdf');
                document.body.appendChild(link);
                link.click();
              });
        } catch (error) {
          console.dir(error)
        }
      },
      onPaginationClick(pageNum) {
        let assigneeId = this.route.params.clientId;
        this.fetchReports(assigneeId, this.paginate.perPage, pageNum);
        this.onPaginationBtnClick(pageNum);
      }
    },
  };
</script>


// WEBPACK FOOTER //
// src/modules/randomRotation/components/RotationReport.vue